import { EdgeItemsType, EdgeItemType } from 'data/types';
import { defaultOpeningWidthFt } from 'utils/opening-drag';
import { resolveOpeningOffsets } from 'utils/opening-position';
import {
  EdgeRunType,
  OpeningPlacementType
} from 'utils/opening-position-types';
import { openingLayoutsFromEdgeItems } from 'utils/opening-run-layout';
import { OpeningRunLayoutType } from 'utils/opening-run-layout-types';
import DraggableEdgeItem from './draggable-edge-item';
import EdgeOpening from './edge-opening';

type SpaceEdgeOpeningsProps = {
  edgeItems: EdgeItemsType;
  edgeRuns: EdgeRunType[];
  layouts?: OpeningRunLayoutType[] | null;
  spaceId: string;
  zoom: number;
  dragItemId?: string;
  dragPlacement: OpeningPlacementType | null;
  interactive?: boolean;
  onContextMenu?: (
    event: React.MouseEvent,
    item: EdgeItemType,
    run: EdgeRunType
  ) => void;
};

export default function SpaceEdgeOpenings({
  edgeItems,
  edgeRuns,
  layouts,
  spaceId,
  zoom,
  dragItemId,
  dragPlacement,
  interactive = true,
  onContextMenu
}: SpaceEdgeOpeningsProps) {
  const resolvedLayouts =
    layouts && layouts.length > 0
      ? layouts
      : openingLayoutsFromEdgeItems(edgeItems, edgeRuns);

  return (
    <>
      {resolvedLayouts.map((layout) => {
        const { run, items } = layout;
        if (items.length === 0) {
          return null;
        }

        const offsets = resolveOpeningOffsets(
          items.map((item) => ({
            id: item.id,
            widthFt: item.width ?? defaultOpeningWidthFt(item.type),
            positionOnWall: item.positionOnWall
          })),
          run.lengthFt
        );

        return items.map((item, index) => {
          const offsetFt = offsets[index]?.offsetFt ?? 0;
          const openingKey = `${item.id}-${run.edge}-${run.start.x}-${run.start.y}-${run.lengthFt}`;
          if (!interactive) {
            return (
              <EdgeOpening
                key={openingKey}
                item={item}
                edge={run.edge}
                offsetFt={offsetFt}
                run={run}
                zoom={zoom}
              />
            );
          }

          return (
            <DraggableEdgeItem
              key={openingKey}
              item={item}
              edge={run.edge}
              spaceId={spaceId}
              offsetFt={offsetFt}
              run={run}
              placement={item.id === dragItemId ? dragPlacement : null}
              zoom={zoom}
              onContextMenu={(event) => onContextMenu?.(event, item, run)}
            />
          );
        });
      })}
    </>
  );
}
